/**
 * 
 * @copyright     (c) 2024-2025 Gist Applications Inc.
 * @author        Greg Olive greg@gist-apps.com
 * @package       gift-card-pro
 * 
 * /assets/js/React/Proxy/_components/TextField/index.js
 * Created:       Wed Mar 06 2024
 * Modified By:   Greg Olive
 * Last Modified: Tue Apr 22 2025
 */

import React, { useState } from "react";

import {
  validateInput
} from "./textFieldUtils.js"

/**
 * The FormInput component has a Label component and an Input component. If
 * the "label" prop is not given then just the Input component will be rendered.
 *
 * @param { string } label -> The label for the input. If label is not defined
 *                            no label will be displayed.
 *
 * @param { string } placeholder -> The placeholder for the input. If placeholder
 *                                  is not defined no placeholder will be displayed.
 *
 * @param { string } validation -> The type of validation that will be used for
 *                                 the input value.
 *
 * @param { function } onChange -> The funtion that will be run on the input value.
 */
export default function TextField({
  value,
  name,
  type,
  onChange,
  onClick = () => {},
  label = null,
  placeholder = null,
  validation = null,
  min = 0.01,
  step = 0.01,
  max = 500,
  error = null,
  className = null,
}) {

  const hasError = error && error.error === true;
  const style = (hasError) ? "gc__input_field_error" : "";

  const errorMarkup = hasError && <p className={"gc__input_field_error_message"}>{ error.message }</p>

  return (
    <>
      <div className={(className) ? `gc__input_container ${className}--container` : "gc__input_container"}>
        {(label) ?
          <label className={(className) ? `gc__input_label ${className}--label` : "gc__input_label"}>
            {label}
          </label>
        : null}
        <input
          className={(className) ? `gc__input_field ${style} ${className}--input` : `gc__input_field ${style}`}
          name={name}
          type={type}
          min={min}
          step={step}
          max={max}
          value={value}
          placeholder={placeholder}
          onChange={e => onChange(e)}
        />
      </div>
      {(hasError) ?
        <p className={"gc__input_field_error_message"}>
          {error.message}
        </p>
      : null}
    </>
  )
}
